import { useEffect, useState, useRef } from "react";
import debounce from "lodash/debounce";
import { getPokemonSearchBar } from "../apis/pokemons";
import { BasicPokemonInfoI } from "interfaces";

export function useFetchSearchBar(
  searchTerm: string
): [BasicPokemonInfoI[], boolean, string] {
  const [pokemons, setPokemons] = useState<BasicPokemonInfoI[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const debouncedFetchData = useRef(
    debounce(async (searchTerm: string) => {
      if (searchTerm === "") {
        return;
      }
      try {
        setIsLoading(true);
        const fetchedPokemons: BasicPokemonInfoI[] = await getPokemonSearchBar(
          searchTerm
        );
        setIsLoading(false);
        setPokemons(fetchedPokemons);
      } catch (error) {
        setIsLoading(false);
        setError("Error");
      }
    }, 300)
  ).current;

  useEffect(() => {
    debouncedFetchData(searchTerm);

    return () => {
      debouncedFetchData.cancel();
    };
  }, [searchTerm, debouncedFetchData]);

  return [pokemons, isLoading, error];
}
